import { RootState } from '@dealstack/frontend/app/redux/store';

// User ID of the programme member
export const selectSelectedProgrammeMemberId = (state: RootState) =>
	state.mipManage.selectedProgrammeMemberId;

export const selectShouldDisableIsContactPerson = (state: RootState) =>
	state.mipManage.shouldDisableIsContactPerson;
